module.exports = __webpack_public_path__ + "img/custom.61a9d5ae.png";